import React from "react";
import ArticleCardA from "components/mui/cards/articleCardA";
import {
  NarrowContainer,
  WideContainer,
} from "components/mui/containers/PxftContainer";
import { Grid } from "@mui/material";
import Slide from "@mui/material/Slide";
import Grow from "@mui/material/Grow";
import { useInView } from "react-intersection-observer";

const Overview = () => {
  const article = {
    title: "Agentic AI-Powered Programmatic Technology",
    content:
      "PixFuture is the only Agentic AI platform built by publishing veterans. We've walked in your shoes — and now our AI agents do the heavy lifting, autonomously optimizing video & display monetization so you reach your revenue goals faster, with less effort.",
  };
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const containerRef = React.useRef(null);
  return (
    <WideContainer className="home-overview-container">
      <div className="center-align">
        <NarrowContainer className="overview-content">
          <Grow timeout={{ enter: 1200 }} in={inView}>
            <Grid item xs={12} sm={6} md={8} className="overview-left">
              <div className="overview-pic">
                <img
                  loading="lazy"
                  className="ai-agent-image"
                  src="/images/publishers/example-ai0-agent.png"
                  alt="overview"
                />
              </div>
            </Grid>
          </Grow>
          <Slide
            timeout={{ enter: 1200 }}
            in={inView}
            direction="left"
            container={containerRef.current}
          >
            <Grid item xs={12} sm={6} md={4} className="center-align">
              <div className="overview-article-card">
                <ArticleCardA
                  title={article.title}
                  content={article.content}
                  link="about-us"
                />
              </div>
            </Grid>
          </Slide>
          <div className="observer" ref={inViewRef}></div>
        </NarrowContainer>
      </div>
    </WideContainer>
  );
};

export default Overview;
